import { useOverlayClose } from "../../hooks/useOverlayClose";

export default function ModalOverlay({ onClose, children, ...rest }) {
  const overlayCloseProps = useOverlayClose(onClose);
  return (
    <div {...rest} {...overlayCloseProps}>
      {children}
    </div>
  );
}
